// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconGame = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.6737 9.11579C15.1983 9.01891 13.6891 8.9397 11.9989 8.9397C10.3087 8.9397 8.79952 9.01891 7.32413 9.11579C4.90831 9.27441 2.89197 11.0866 2.6599 13.4965C2.48306 15.333 2.36203 17.3163 2.35416 19.1617C2.34353 21.65 4.69488 23.8107 6.6979 22.3344C7.83424 21.4969 8.39872 20.3033 8.56456 19.1705H15.4333C15.5991 20.3033 16.1636 21.4969 17.3 22.3344C19.303 23.8107 21.6543 21.65 21.6437 19.1617C21.6358 17.3163 21.5147 15.333 21.338 13.4965C21.1059 11.0866 19.0896 9.27441 16.6737 9.11579Z',
      fill: 'current'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.6326 11.4307C21.0163 12.038 21.2662 12.7375 21.3393 13.4963C21.5162 15.3328 21.6372 17.3162 21.6451 19.1615C21.6557 21.6497 19.3042 23.8106 17.3013 22.3343C16.165 21.4967 15.6005 20.3032 15.4346 19.1704H8.56592C8.40008 20.3032 7.8356 21.4967 6.69926 22.3343C4.69624 23.8106 2.34489 21.6497 2.3555 19.1615C2.36339 17.3162 2.48442 15.3328 2.66126 13.4963C2.73433 12.7375 2.9843 12.038 3.36793 11.4307',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.09943 8.95047C8.67518 9.12711 10.3156 9.33452 12.0005 9.33452C13.6853 9.33452 15.3258 9.12711 16.9015 8.95047C17.7242 8.85824 18.3801 8.20594 18.456 7.38154C18.6341 5.45048 18.8446 2.97471 18.8446 1.28564L14.7364 3.71628L12.0005 1.28564L9.26457 3.71628L5.15625 1.28564C5.15625 2.97471 5.36678 5.45048 5.5449 7.38154C5.62094 8.20592 6.27669 8.85824 7.09943 8.95047Z',
      fill: 'current'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.09943 8.95047C8.67518 9.12711 10.3156 9.33452 12.0005 9.33452C13.6853 9.33452 15.3258 9.12711 16.9015 8.95047C17.7242 8.85824 18.3801 8.20594 18.456 7.38154C18.6341 5.45048 18.8446 2.97471 18.8446 1.28564L14.7364 3.71628L12.0005 1.28564L9.26457 3.71628L5.15625 1.28564C5.15625 2.97471 5.36678 5.45048 5.5449 7.38154C5.62094 8.20592 6.27669 8.85824 7.09943 8.95047Z',
      fill: 'current',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.99768 13.9414H9.81573',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.40735 12.5327V15.3508',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.6813 13.9414V14.3141',
      stroke: 'current',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconGame };
